import { Destroyer, LocaleService } from '@adaptiva/core/common';
import { LoggingService } from '@adaptiva/core/logging';
import { BaseThemeService } from '@adaptiva/core/themes';
import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';

@Component({
	standalone: false,
	selector: 'ada-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent extends Destroyer implements OnInit, OnDestroy {

	protected readonly logger: LoggingService = inject(LoggingService);

	protected readonly themes: BaseThemeService = inject(BaseThemeService);

	protected readonly locale: LocaleService = inject(LocaleService);

	public ngOnInit(): void {
		this.themes.setup().pipe(this.takeOneUntilDestroyed()).subscribe();

		this.locale.loadBrowserLocale().pipe(this.takeOneUntilDestroyed()).subscribe({
			error: (e: Error) => {
				this.logger.error('AppComponent.ngOnInit', e)();
			}
		});
	}

}
